import { FunctionComponent, useContext, useEffect, useState } from "react";
import TitleText from "../../components/shared-components/dashboard/TitleText";
import styles from "./Affiliate.module.css";
import images from "../../assets/images";
import AppTable from "../../components/shared-components/table/AppTable";
import { Button, CircularProgress, Dialog, Menu } from "@mui/material";
import AddAffiliate from "../../components/shared-components/add-affiliate/AddAffiliate";
import { useLazyQuery } from "@apollo/client";
import { AFFILIATE_TYPE_BOTH, GET_AFFILIATE_COUNT, GET_AFFILIATE_TRANSACTIONS, GET_AFFILIATES, GET_ALL_AFFILIATES } from "./api/AffiliateQuery";
import ToasterWithMessage from "../../components/shared-components/toaster";
import { globalContext } from "../../Provider/AppProvider";
import PopupComponent from "../../components/shared-components/success-popup/PopupComponent";
import { CustomPaperComponent, getFormattedDate } from "../../helper";
import stylesUser from '../Users/Users.module.css'
import { GET_NOTIFICATIONS } from "../../components/shared-components/notification/api/NotificationQuery";
import AffiliateFilterDropdown from "../../components/shared-components/dropdown/filter-dropdown/AffiliateFilterDropdown";
import { useLocation } from "react-router-dom";
import AffiliateTransactionsFilterDropdown from "../../components/shared-components/dropdown/filter-dropdown/AffiliateTransactionsFilterDropdown";

interface usersUnderAffiliateUser {
    id: string,
    affiliateId: string,
    userFullName: string,
    affiliater_ticket_details: any,
    totalEarnings: number | null,
    noOfUsers: any
}
export interface affiliateUser {
    firstName: string,
    lastName: string,
    emailId: string,
    user: usersUnderAffiliateUser
}


interface affiliateCount{
  aggregate: {
    count: number
  }
}
export interface getAffiliates {
  aId: string,
  aType: string,
  totalAmount: number,
  directPayout: number,
  emailId: string,
  firstName: string,
  indirectPayout: number,
  lastName: string,
  noOfAffiliates: number | null,
  noOfUsers: number | null,
  referralCode: string | null,
  uId: string,
  userFullName: string,
  aStatus: string,
  aCreatedAt: string,
  aUpdatedAt: string,
}

export interface getAffiliateTransactionsType {
    ut_type: 'Direct' | 'Indirect' | 'Both',
    ut_transaction_status: string,
    ut_transaction_id: string,
    ut_transaction_date: string,
    ut_transaction_amount: number,
    ut_invoice_number: string,
    ut_payout_status: string
}
export interface affiliateTransactionsListType {
  affiliateTransactions : getAffiliates[],
  affiliateTransactionsCount: number,
}

const AffiliateTransactions: FunctionComponent = () => {
  localStorage.removeItem('ticketsTabIndex');
  localStorage.removeItem('errorTabIndex');
  localStorage.removeItem('settingsTabIndex');
  const { dropdownIcon, GreyFilterIcon} = images;
//   const { AddIcon } = images;
//   const StyledComponent = CustomPaperComponent();
  const {error} = ToasterWithMessage();
  const location = useLocation();
  const [affiliateDetailsView, setAffiliateDetailsView] = useState<boolean>(false);
  const title = "Transactions"
  const [tempRowsPerPage, setTempRowsPerPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(tempRowsPerPage ? tempRowsPerPage : "") || 10
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [checking, setChecking] = useState<boolean>(false);
  const [selected, setSelected] = useState<number[]>([]);
  const [columnTypes, setColumnTypes] = useState<string>("aUpdatedAt");
  const [sortType, setSortType] = useState<string>("desc");
  const [affiliateTransactions, setAffiliateTransactions] = useState<affiliateTransactionsListType>();
//   const [openDialog, setOpenDialog] = useState<boolean>(false)
  const {globalState, handleGlobalState} = useContext <any>(globalContext)
//   const [affiliateSuccess, setAffiliateSuccess] = useState<boolean>(false);
  const [searchvalue, setSearchvalue] = useState(globalState?.globalSearch?.searchtext);
  const [anchorElFilter, setAnchorlFilter] = useState(null);
  const openFilter = Boolean(anchorElFilter);

  useEffect(() => {
    const tempdata = {...globalState}
    setSearchvalue(tempdata?.globalSearch?.searchtext)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.globalSearch?.searchtext]);

  const [getAffiliateTransactions,{loading}] = useLazyQuery(GET_AFFILIATE_TRANSACTIONS,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setAffiliateTransactions((prevState) => ({
        ...prevState,
        affiliateTransactions: data?.user_transactions ?? prevState?.affiliateTransactions ?? [],
        affiliateTransactionsCount: data?.user_transactions_aggregate?.aggregate?.count ?? prevState?.affiliateTransactionsCount ?? 0
      }));
    //   const tempData = {...globalState};
    //   if(tempData.affiliateAdded.added){
    //     setAffiliateSuccess(true);
    //     tempData.affiliateAdded.added = false;
    //   }
    //   if(tempData.affiliateDelete.deleted){
    //     tempData.affiliateDelete.deleted = false;
    //   }
    //   if(tempData.affiliateUpdate.updated){
    //     tempData.affiliateUpdate.updated = false;
    //   }
    //   handleGlobalState(tempData);
    },
    onError: () => {
      error("Failed to fetch Affiliate transactions");
    }
  })
//   const [getAffiliateCount] = useLazyQuery(GET_AFFILIATE_COUNT,{
//     fetchPolicy: "no-cache",
//     onCompleted: (data)=>{
//       setAffiliateTransactions((prevState) => ({
//         ...prevState,
//         getAffiliates: prevState?.getAffiliates ?? [],
//         getAffiliatesCount: data?.GetAffiliatesCount?.[0]?.totalCount ?? prevState?.getAffiliatesCount ?? 0
//       }));
//     },
//     onError : () =>{
//       error("Spmething went wrong!");
//     }
//   })
  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setTempRowsPerPage(event.target.value);
  };

  const handlePageChange = (_event: any, newPage: any) => {
    setCurrentPage(newPage);
    setChecking(false);
    setSelected([]);
  };

  const GenerateUsersHeadCells = () => {
    const id = [
        "ut_transaction_id",
        "ut_transaction_amount",
        "ut_transaction_date",
        "ut_type",
        "ut_transaction_status",
        "ut_invoice_number",
        "ut_payout_status"
    ];
    const labels = [
        "Transaction Id",
        "Transaction Amount",
        "Transaction Date",
        "Transaction Type",
        "Transaction Status",
        "Invoice Number",
        "Payout Status"
    ];
    const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
  };

//   const handleOpenDialogAddAffiliate = () =>{
//     setOpenDialog(true)
//   }

//   const handleCloseDialogAddAffiliate = () =>{
//     setOpenDialog(false)
//   }
  useEffect(() => {
    getAffiliateTransactions({
      variables: {
        limit: 10,
        offset: 0,
        order_by: {[columnTypes]: sortType},
        searchText: `%${searchvalue}%`,
        userId: location.state.id
    }
    })
    // getAffiliateCount({
    //   variables:{
    //     searchText: `%${searchvalue}%`,
    //     aStatus: globalState.affiliateFilter.status ? globalState.affiliateFilter.status : null,
    //     aType: globalState.affiliateFilter.typeName ? globalState.affiliateFilter.typeName : null
    //   }
    // })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=> {
    getAffiliateTransactions({
      variables: {
        limit: rowsPerPage,
        offset: (currentPage -1)*rowsPerPage,
        order_by: {[columnTypes]: sortType},
        searchText: `%${searchvalue}%`,
        userId: location.state.id
    }
    })
    // getAffiliateCount({
    //   variables:{
    //     searchText: `%${searchvalue}%`,
    //     aStatus: globalState.affiliateFilter.status ? globalState.affiliateFilter.status : null,
    //     aType: globalState.affiliateFilter.typeName ? globalState.affiliateFilter.typeName : null
    //   }
    // })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[currentPage,rowsPerPage,sortType,columnTypes,getAffiliateTransactions])

  // useEffect(() => {
  //   getAffiliateTransactions({
  //     variables: {
  //       limit: rowsPerPage,
  //       offset: (currentPage -1)*rowsPerPage,
  //       order_by: {[columnTypes]: sortType},
  //       searchText: `%${searchvalue}%`,
  //       userId: location.state.id,
  //       aStatus: globalState.affiliateTransactionFilter.status ? globalState.affiliateTransactionFilter.status : null,
  //       aType: globalState.affiliateTransactionFilter.typeName ? globalState.affiliateTransactionFilter.typeName : null
  //   }
  //   })
  //   // getAffiliateCount({
  //   //   variables:{
  //   //     searchText: `%${searchvalue}%`,
  //       // aStatus: globalState.affiliateFilter.status ? globalState.affiliateFilter.status : null,
  //       // aType: globalState.affiliateFilter.typeName ? globalState.affiliateFilter.typeName : null
  //   //   }
  //   // })
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[
  //   // globalState?.globalSearch?.searchtext,searchvalue,
  //   globalState.affiliateTransactionFilter.typeName,globalState.affiliateTransactionFilter.status
  // ])
  
//   useEffect(()=>{
//     if(globalState.affiliateAdded.added || globalState.affiliateDelete.deleted || globalState.affiliateUpdate.updated){
//         getAffiliateTransactions({
//         variables: {
//           limit: rowsPerPage,
//           offset : (currentPage -1)*rowsPerPage,
//           order_by: {[columnTypes]: sortType},
//         searchText: `%${searchvalue}%`,
//         aStatus: globalState.affiliateFilter.status ? [globalState.affiliateFilter.status] : ["Active", "Deactive"],
//         aType: globalState.affiliateFilter.typeName ? [globalState.affiliateFilter.typeName] : ["Both"]
//       }
//       })
//     //   getAffiliateCount({
//     //     variables:{
//     //       searchText: `%${searchvalue}%`,
//     //       aStatus: globalState.affiliateFilter.status ? globalState.affiliateFilter.status : null,
//     //       aType: globalState.affiliateFilter.typeName ? globalState.affiliateFilter.typeName : null
//     //     }
//     //   })
//     }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   },[globalState.affiliateAdded.added,globalState.affiliateDelete.deleted,globalState.affiliateUpdate.updated])

  const [getWebNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempData = {...globalState}
      tempData.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempData.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempData)
    }
  })

//   const [affiliateTypeBoth] = useLazyQuery(AFFILIATE_TYPE_BOTH,{
//     fetchPolicy: "no-cache",
//     onCompleted: (data) => {
//       const tempState = {...globalState};
//       tempState.affiliateFilter.typeName = data?.affiliate_type?.[0]?.type || "Both";
//       handleGlobalState(tempState)
//     }
//   })


  useEffect(()=>{
    const date = getFormattedDate(new Date());
    const tempState = {...globalState};
    if(globalState.globalSearch.affiliateUsersClicked){
      tempState.globalSearch.searchtext = "";
      tempState.globalSearch.affiliateUsersClicked = false;
    }
    if(globalState.notification.notificationClicked){
      tempState.notification.notificationClicked = false;
      tempState.notification.tp_id_array=null;
      tempState.globalSearch.searchtext = "";
      tempState.notification.text = "";
      tempState.notification.ticketId =null;
      tempState.notification.tpId = null;
    }else if(globalState.error.errorClicked){
      tempState.error.errorClicked = false;
      tempState.globalSearch.searchtext = "";
      tempState.error.text = "";
      tempState.error.approximateTpArray = null
      tempState.error.ticketPlacementId = null
      tempState.error.status = ""
    }else if(globalState.soldTickets.failed){
      tempState.soldTickets.failed = false
      tempState.globalSearch.searchtext = "";
      tempState.soldTickets.emailId = "";
    }
    // if(!tempState.affiliateFilter.typeId && !tempState.affiliateFilter.typeName){
    //   affiliateTypeBoth();
    // }
    handleGlobalState(tempState)
    if(globalState.profile.userRole !== "marketing_user"){
      getWebNotification({
        variables:{
          todayDate: date,
          userId: globalState?.profile?.id
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const handleClickopenFilter = (event: any) => {
    setAnchorlFilter(event.currentTarget);
  }

  const handleCloseFilter = () => {
    setAnchorlFilter(null);
  };

  return (
    <div style={{ width: "100%" }}>
      <>
        <div className={styles.userHeading}>
          <TitleText title={title}/>


          {/* {(globalState.globalSearch.searchtext !== '') && <div className={styles.filterResultCount}>Search Results<span className={styles.filterCount}>({affiliateUsers?.getAffiliates?.length})</span></div>} */}



{/* 
          <div className={styles.filter} onClick={handleClickopenFilter}>
              <span className={styles.filterIconStyle}>
               <img src={GreyFilterIcon} alt={"filtericon"} /> 
              </span>
              <span>Filter</span>
          </div> */}
          {/* { globalState.profile.userRole === "marketing_user" ?
            null :
            <div className={styles.addAffiliate} onClick={handleOpenDialogAddAffiliate}>
            <Button
              classes={{ root: styles.separateStyle }}
              disableRipple
              fullWidth
              type="submit"
            >
             <img src={AddIcon} alt="addIcon" className={styles.addIcon}/>Add
            </Button>
          </div>} */}
        </div>
        {
          loading
        ?  
          <div className={stylesUser.TableCircularProgress}>
          <CircularProgress color="primary" size={35} />
          </div>
        :
        <AppTable
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handlePageChange={handlePageChange}
          setColumnTypes={setColumnTypes}
          sortType={sortType}
          setSortType={setSortType}
          setSelected={setSelected}
          setChecking={setChecking}
          checking={checking}
          selected={selected}
          rowsPerPage={rowsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          list={affiliateTransactions}
          tableTitle="affiliateTransactions"
          generateHeadCells={GenerateUsersHeadCells}
          affiliateDetailsView={affiliateDetailsView}
          setAffiliateDetailsView={setAffiliateDetailsView}
        />
        }
      </>
      
      <Menu
            anchorEl={anchorElFilter}
            id="account-menu"
            open={openFilter}
            onClose={handleCloseFilter}
            transformOrigin={{ horizontal: "left", vertical: "top" }}
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            MenuListProps={{
              disablePadding: true,
            }}
            classes={{
              paper: styles.customMenu,
            }}
          >
            <AffiliateTransactionsFilterDropdown  handleCloseFilterDropDown={handleCloseFilter} aType = {location.state.aType} />
          </Menu>
    </div>
  );
};

export default AffiliateTransactions;
